import { ProgramTaskBase } from '@vestahealthcare/common/models';

import Api from './Api';

export const fetchProgramTask = async (
  id: number,
): Promise<ProgramTaskBase> => {
  const { task } = await Api.getv2(`program-tasks/${id}`);
  return new ProgramTaskBase(task);
};

export type UpdateProgramTaskParams = {
  adminStatus?: string;
};

export const updateProgramTask = async (
  id: number,
  params: UpdateProgramTaskParams,
): Promise<ProgramTaskBase> => {
  const { task } = await Api.patchv2JSON(`program-tasks/${id}`, params);
  return new ProgramTaskBase(task);
};
